export default {
  template: `
    <users>
      <users-menu>
        <menu-container selected="users"></menu-container>
      </users-menu>
      <users-list>
        <users-list-container
          selected-id="$ctrl.selectedId"
        ></users-list-container>
      </users-list>
      <users-content>
        <users-brands-list-container
          ng-if="!$ctrl.subSection"
          selected-id="$ctrl.selectedId"
        ></users-brands-list-container>
        <users-activities-container
          ng-if="$ctrl.subSection === 'activities'"
          selected-id="$ctrl.selectedId"
        ></users-activities-container>
        <users-permissions-modal-container></users-permissions-modal-container>
        <users-revoke-modal-container></users-revoke-modal-container>
        <users-edit-modal-container></users-edit-modal-container>
        <users-brand-admin-modal-container></users-brand-admin-modal-container>
      </users-content>
    </users>
  `,
  bindings: {
    selectedId: '@',
    subSection: '@',
  },
};
